import Phaser from 'phaser';
import { JUSTICE_FRAME_START, getJusticeFrame } from '../../data/npcRegistry';

export function createJusticeAnimations(scene: Phaser.Scene): void {
  const anims = scene.anims;
  const textures = scene.textures;
  const atlasKey = 'supreme_court_spritesheet';

  // Check if atlas is loaded
  if (!textures.exists(atlasKey)) {
    console.warn(`[justiceAnimations] Atlas '${atlasKey}' not loaded, skipping animations`);
    return;
  }

  const atlasFrames = textures.get(atlasKey).getFrameNames();
  const frameSet = new Set(atlasFrames);

  const justices = Object.keys(JUSTICE_FRAME_START);

  let createdCount = 0;
  let skippedCount = 0;

  for (const justice of justices) {
    // Create idle animation using the first frame for each justice
    const idleFrame = getJusticeFrame(justice, 0);
    const animKey = `${justice}_idle`;

    if (!frameSet.has(idleFrame)) {
      console.warn(`[justiceAnimations] Frame '${idleFrame}' not found for ${justice}`);
      skippedCount++;
      continue;
    }

    try {
      anims.create({
        key: animKey,
        frames: [{ key: atlasKey, frame: idleFrame }],
        frameRate: 1,
        repeat: -1,
      });
      createdCount++;
    } catch (e) {
      console.warn(`[justiceAnimations] Failed to create animation '${animKey}':`, e);
    }
  }

  console.info(`[justiceAnimations] Created ${createdCount} animations, skipped ${skippedCount} (frames not found)`);
}
